import { InspectorControls, useBlockProps } from "@wordpress/block-editor";
import { useEffect } from "@wordpress/element";

import { getExtraDOMAttributes } from "../utils";
import AllInspectorSettings from "./InspectorControls";
import "../style.scss";

let watchDebounceId;

export default function Edit(props) {
  const { attributes, setAttributes, clientId } = props;
  const { currentAddress, locations } = attributes;

  // One-time migration: seed locations from legacy single-address attribute
  useEffect(() => {
    if (currentAddress && (!locations || locations.length === 0)) {
      setAttributes({ locations: [{ address: currentAddress }], currentAddress: "" });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const blockProps = useBlockProps(getExtraDOMAttributes(attributes));

  useEffect(() => {
    clearTimeout(watchDebounceId);
    watchDebounceId = setTimeout(() => {
      const currentBlock = document.getElementById(`block-${clientId}`);
      if (currentBlock) {
        window.dispatchEvent(
          new CustomEvent("bb_map_attribute_changed", {
            detail: {
              block: currentBlock,
            },
          })
        );
      }
    }, 500);
  }, [attributes, clientId]);

  return (
    <>
      <InspectorControls>
        <AllInspectorSettings
          setAttributes={setAttributes}
          attributes={attributes}
          clientId={clientId}
        />
      </InspectorControls>
      <div {...blockProps}>
        <div className="brandy-blocks-map"></div>
      </div>
    </>
  );
}
